import { Flex, InlineLink, Text } from '@fullstory/components';
import { HelpSidecarNavigator } from '@fullstory/overlays-ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

export const ContactUs: React.FunctionComponent = () => {
  const history = useHistory();
  const location = useLocation();

  const navigateToSidecarUrl = (): void => {
    HelpSidecarNavigator({ history, location });
  };

  return (
    <Flex data-component="ContactUs" justifyContent="center" column>
      <Text appearance="bodySmall">
        <FormattedMessage
          defaultMessage="<a1>Learn More</a1> about Page Insights."
          id="saxSfk"
          values={{
            a1(text) {
              return (
                <InlineLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://help.fullstory.com/hc/en-us/articles/360020624074"
                >
                  {text}
                </InlineLink>
              );
            },
          }}
        />
      </Text>
      <Text appearance="bodySmall">
        <FormattedMessage
          defaultMessage="Have questions? <a1>Contact us.</a1>"
          id="+rCpbC"
          values={{
            a1(text) {
              return <InlineLink onClick={navigateToSidecarUrl}>{text}</InlineLink>;
            },
          }}
        />
      </Text>
    </Flex>
  );
};
